import { ChevronRight } from 'react-bootstrap-icons';
import './styles/index.css';

const steps = [
  { label: 'Reservation type', completed: true },
  { label: 'Dates', completed: false },
  { label: 'Guest Information', completed: false },
  { label: 'Room Reassignment', completed: false },
];

const getStepClass = (index: number, currentStep: number, completed: boolean) => {
  if (index === currentStep) return 'active';
  if (completed) return 'completed';
  return '';
};

const Stepper = ({
  currentStep = 1,
  setStep,
}: {
  currentStep: number;
  setStep?: (step: number) => void;
}) => {
  return (
    <div className="stepper-container">
      {steps.map((step, index) => (
        <div
          onClick={() => (setStep ? setStep(index) : undefined)}
          className="stepper-step d-flex align-items-center"
        >
          <div
            className={`step-circle ${getStepClass(index, currentStep, step.completed)}`}
          >
            {index + 1}
          </div>
          <span
            className={`step-label ${getStepClass(index, currentStep, step.completed)}`}
          >
            {step.label}
          </span>
          {index < steps.length - 1 && (
            <span className="step-separator">
              <ChevronRight size={18} />
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

export default Stepper;
